// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Int from "@rescript/core/src/Core__Int.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as CardPattern$OrcaPaymentPage from "./validation/CardPattern.bs.js";

function toInt(val) {
  return Core__Option.getOr(Core__Int.fromString(val, undefined), 0);
}

function getobjFromCardPattern(cardBrand) {
  return Core__Option.getOr(CardPattern$OrcaPaymentPage.cardPatterns.filter(function (item) {
                    return cardBrand === item.issuer;
                  })[0], CardPattern$OrcaPaymentPage.defaultCardPattern);
}

function clearSpaces(value) {
  return value.replace(/\D+/g, "");
}

function slice(val, start, end) {
  return val.slice(start, end);
}

function getAllMatchedCardSchemes(cardNumber) {
  return Core__Array.reduce(CardPattern$OrcaPaymentPage.cardPatterns, [], (function (acc, item) {
                if (Core__Option.isSome(Caml_option.nullable_to_opt(cardNumber.match(item.pattern)))) {
                  acc.push(item.issuer);
                }
                return acc;
              }));
}

function isCardSchemeEnabled(cardScheme, enabledCardSchemes) {
  return enabledCardSchemes.includes(cardScheme);
}

function formatCVCNumber(val, cardType) {
  var clearValue = clearSpaces(val);
  var obj = getobjFromCardPattern(cardType);
  return clearValue.slice(0, obj.maxCVCLength);
}

function getStrFromIndex(arr, index) {
  return Core__Option.getOr(arr[index], "");
}

function splitExpiryDates(val) {
  var split = val.split("/");
  var value = split.map(function (item) {
        return item.trim();
      });
  var month = Core__Option.getOr(value[0], "");
  var year = Core__Option.getOr(value[1], "");
  return [
          month,
          year
        ];
}

function formatCardExpiryNumber(val) {
  var clearValue = clearSpaces(val);
  var expiryVal = toInt(clearValue);
  var formatted;
  if (expiryVal >= 2 && expiryVal <= 9 && clearValue.length === 1) {
    formatted = "0" + clearValue + " / ";
  } else if (clearValue.length === 2 && expiryVal > 12) {
    var val$1 = clearValue.split("");
    formatted = "0" + getStrFromIndex(val$1, 0) + " / " + getStrFromIndex(val$1, 1);
  } else {
    formatted = clearValue;
  }
  if (clearValue.length >= 3) {
    return formatted.slice(0, 2) + " / " + formatted.slice(2, 4);
  } else {
    return formatted;
  }
}

export {
  toInt ,
  getobjFromCardPattern ,
  clearSpaces ,
  slice ,
  getAllMatchedCardSchemes ,
  isCardSchemeEnabled ,
  formatCVCNumber ,
  getStrFromIndex ,
  splitExpiryDates ,
  formatCardExpiryNumber ,
}
/* No side effect */
